// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoTps_wrapper__2bZme","logo":"LogoTps_logo__t0jNr"};